import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Platform } from "@ionic/angular";
import { GlobalsService } from "src/app/api/globals.service";
import { StorageService } from "src/app/services/storage.service";
import { TimerService } from "src/app/services/timer.service";

@Component({
  selector: "app-falso-verdadero",
  templateUrl: "./falso-verdadero.component.html",
  styleUrls: ["./falso-verdadero.component.scss"],
})
export class FalsoVerdaderoComponent implements OnInit {
  fvPregunta: string;
  public fvFV: string = "";
  public activityCourse: any;
  @Input() public curso: any;
  @Input() public DATA: any;
  @Input() public ID_TIPO_LC: any;
  @Output() public isvalid = new EventEmitter<boolean>();
  @Output() public name = new EventEmitter<string>();

  private ID_TIPO = 2;
  private ID_ACTIVIDAD = 0;
  sqliteStorage: boolean = false;
  sqliteStorageData: any = null;
  inicio_actividad_key: string;
  ismobile: boolean;
  private readonly table = "actividades_respuestas_data";
  constructor(
    private storageService: StorageService,
    private platform: Platform,
    public globalsService: GlobalsService,
    private timerService: TimerService
  ) {
    this.ismobile = globalsService.isMobile;
  }

  ngOnInit() {
    this.name.emit("Falso Verdadero");
    this.fvFV = "";
    this.platform.ready().then(() => {
      this.ID_ACTIVIDAD = this.DATA.id_actividad;
      let _id_librocurso = this.ID_ACTIVIDAD;
      let id_tipo = this.ID_TIPO;
      let id_ejercicio = this.DATA.id;
      let _id_curso = this.curso.id;
      let _tipo = this.ID_TIPO_LC;
      let _id_user = this.curso.id_user;
      const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}_${id_ejercicio}_${id_tipo}`;
      this.inicio_actividad_key = key;
      this.getStorage();
    });
  }

  async getStorage() {
    let activityCourse: any;

    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          activityCourse = res.find(
            (x) => x.id_actividad == this.ID_ACTIVIDAD && x.id == this.curso.id
          );
          activityCourse.data.forEach((element2, j) => {
            if (
              element2.id_tipo == this.DATA.id_tipo &&
              element2.id == this.DATA.id
            ) {
              this.fvFV = element2.respuesta.r;
              this.timerService.initTimer(element2.timer);
              this.isvalid.emit(true);
            }
          });
        }
      })
      .catch((err) => {
        // Error handling
      });
  }

  setVF(vf) {
    this.fvFV = vf;
    this.isvalid.emit(true);
    if (this.ismobile) {
      let data: any;
      data = {
        id: this.DATA.id,
        id_actividad: this.DATA.id_actividad,
        id_tipo: this.DATA.id_tipo,
        respuesta: {
          r: this.fvFV,
        },
      };
      return;
    }

    this.storageService
      .get("activities")
      .then((res) => {
        if (res) {
          this.activityCourse = res;
          this.activityCourse.forEach((element, i) => {
            if (
              element.id == this.curso.id &&
              element.id_actividad == this.ID_ACTIVIDAD
            ) {
              let data: any;
              data = {
                id: this.DATA.id,
                id_actividad: this.DATA.id_actividad,
                id_tipo: this.DATA.id_tipo,
                respuesta: {
                  r: this.fvFV,
                },
              };
              if (element.data.length == 0) {
                element.data.push(data);
              } else {
                let find: boolean = false;
                element.data.forEach((element2, j) => {
                  if (
                    element2.id_tipo == this.DATA.id_tipo &&
                    element2.id == this.DATA.id
                  ) {
                    element.data[j] = data;
                    find = true;
                  }
                });
                if (!find) {
                  element.data.push(data);
                }
              }
            }
          });
          this.storageService.storage("activities", this.activityCourse);
        } else {
          this.storageService.storage("activities", this.activityCourse);
        }
      })
      .catch((err) => {
        // Error handling
      });
  }
}
